import { render, staticRenderFns } from "./NFTItem.vue?vue&type=template&id=b371dd14&scoped=true&"
import script from "./NFTItem.vue?vue&type=script&lang=js&"
export * from "./NFTItem.vue?vue&type=script&lang=js&"
import style0 from "./NFTItem.vue?vue&type=style&index=0&id=b371dd14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b371dd14",
  null
  
)

export default component.exports